<template>
  <div class="mb-0 h-100 position-relative">
    <div v-if="baseHeading">
      <base-heading
        :level="2"
        class="pt-0 pb-2 title-card"
      >
        Opens by Device
      </base-heading>
    </div>
    <div v-else>
      <base-text
        class="pt-3 pb-2 title-card"
        size="s"
      >
        Opens by device
      </base-text>
    </div>
    <div
      :style="`background-color: ${hasBackground ? color : ''}`"
      class="wrapper d-flex flex-column justify-content-between"
      :class="absolute ? `position-absolute` : ''"
    >
      <div class="row">
        <div class="col-12 py-4 d-flex justify-content-center">
          <template v-if="allEmpty">
            <base-icon
              icon="empty-chart"
              :style="`height: ${size}px; width: ${size}px`"
            />
          </template>
          <template v-else>
            <simple-pie-chart
              :chartdata="chartData"
              :options="options"
              :styles="{
                'height': `${options.height}px`,
                'width': `${options.width}px`
              }"
            />
          </template>
        </div>
      </div>
      <div :class="`row px-5 pb-4 d-flex justify-content-between`">
        <div
          v-for="(entry, index) in entries"
          :key="`entrylabel_${entry.name}`"
          class="text-left"
        >
          <div
            class="legend-icon d-flex justify-content-center align-items-center"
            :style="`background-color: ${colorFromIndex(index)}; margin-left: auto; margin-right: auto`"
          >
            <base-icon :icon="iconOptions[entry.name]" />
          </div>
          <base-text size="m" light class="text-left">
            <div
              class="text-uppercase"
            >
              {{ entry.name }}
            </div>
            <div :style="{opacity: loading? 0 : 1}">
              {{ entry.value | formatFloat(1) }}%
            </div>
          </base-text>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DoughnutChart',
  props: {
    entries: {
      type: Array,
      default: () => ([]),
    },
    hasBackground: {
      type: Boolean,
      default: true,
    },
    baseHeading: {
      type: Boolean,
      default: false,
    },
    cutOutPercentage: {
      type: Number,
      default: 70,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 145,
    },
    absolute: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      color: 'rgba(233,173,125,0.3)',
      pieColors: ['#E9AD7D', '#F2CEB1', '#FFFFFF'],
      options: {
        legend: {
          display: false,
        },
        tooltips: {
          callbacks: {
            label(tooltipItem, data) {
              const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              const label = data.labels[tooltipItem.index];
              return `${label} ${value}%`;
            },
          },
        },
        // custom options
        height: this.size,
        width: this.size,
        cutoutPercentage: this.cutOutPercentage,
      },
      iconOptions: {
        Desktop: 'desktop',
        Mobile: 'mobile',
        Tablet: 'tablet',
      },
    };
  },
  computed: {
    chartData() {
      return {
        labels: this.entries.map((entry) => entry.name),
        datasets: [{
          data: this.entries.map((entry) => (this.loading ? 0 : entry.value)),
          backgroundColor: this.entries.map((entry, index) => this.colorFromIndex(index)),
          borderColor: '#00000000',
          borderWidth: 0,
        }],
      };
    },
    allEmpty() {
      return this.entries.every((item) => Number(item.value) === 0);
    },
  },
  watch: {
    size: {
      handler(newVal) {
        this.options = { ...this.options, height: newVal, width: newVal };
      },
      immediate: true,
    },
  },
  methods: {
    colorFromIndex(index) {
      return this.pieColors[index % this.pieColors.length];
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  border-radius: 8px;
  right: 0;
  left:0;
  top: 40px;
  bottom: 0;
}

.legend-icon {
  border-radius: 50%;
  height: 2rem;
  width: 2rem;
  line-height: 0;
  margin-bottom: 4px;
}
.title-card {
  font-family: 'Tiempos Headline';
  font-weight: 600;
  font-size: 23px;
  line-height: 120%;
  letter-spacing: 0.01em;
  color: #1B1B1B;
}

</style>
